import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Button, Snackbar, Alert } from "@mui/material";
import { fetchUsers } from "../services/ApiService";
import DataTable from "../components/DataTable";

const COLUMNS = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'department', label: 'Department' },
];

export function UserRegister() {
  const navigate = useNavigate();
  const location = useLocation();
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
  const [users, setUsers] = useState([]);

  const loadUsers = async () => {
    try {
      const response = await fetchUsers();
      setUsers(response.data.filter((user) => user.department === "Monit"));
    } catch (error) {
      console.error("Failed to fetch users", error);
    }
  };

  useEffect(() => { loadUsers(); }, []);

  useEffect(() => {
    if (location.state?.successMessage) {
      setSnackbar({ open: true, message: location.state.successMessage, severity: "success" });
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box sx={{ p: 3 }}>
      <DataTable
        title="Technicians"
        columns={COLUMNS}
        rows={users}
        toolbarActions={
          <Button variant="contained" onClick={() => navigate('/technicians/add')}>
            Add User
          </Button>
        }
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
